import React from 'react'
import HomePosts from './Posts'
const Home = () => {
  return (
    <div className='homePosts'>
      <HomePosts />
    </div>
  )
}

export default Home